{
    "GenericAdminList_Footer_Add": "Aggiungere",
    "GenericAdminList_Footer_View": "Visualizzazione",
    "GenericAdminList_Footer_Change": "Modifica",
    "GenericAdminList_Footer_Delete": "Eliminare",
    "GenericAdminList_Footer_Selected": "{} Selezionato",
    "GenericAdminList_Footer_NoRows": "Non c'è niente da vedere qui...",
    "NAME": "GenericAdminListLanguage"
}